<template>
   <div>
      <div class="constrained bg-grey-2">
         <QLayout view="hHR lpr lfr">
            <!--// Header //-->
            <QHeader bordered class="bg-white">
               <QToolbar>
                  <QToolbarTitle class="text-left row items-center">
                     <div class="row items-center">
                        <OrgSwitcher />
                     </div>
                     <div>
                        <ProjectPicker />
                     </div>
                  </QToolbarTitle>
                  <QBtn
                     v-if="$q.screen.width > 768 && !ezbotExtensionInstalled"
                     class="q-mr-md"
                     color="primary"
                     outline
                     size="sm"
                     href="https://chrome.google.com/webstore/detail/dnaacccgllfmhlcjgoehniffflipikpi"
                     target="_blank"
                  >
                     Get the Visual Editor Chrome Extension
                  </QBtn>
                  <UserButton />
                  <LogoutButton />
               </QToolbar>
            </QHeader>
            <!--// Left drawer //-->
            <QDrawer
               v-if="showDrawer"
               v-model="leftDrawerOpen"
               show-if-above
               :mini="leftDrawerMiniState"
               :width="200"
               :breakpoint="500"
               :mini-width="60"
               overlay
               @before-hide="leftDrawerOpen = true"
               @mouseover="leftDrawerMiniState = false"
               @mouseout="leftDrawerMiniState = true"
            >
               <QList>
                  <QItem
                     clickable
                     :active="
                        route.name == 'ProjectHome' ||
                        route.name == 'OnboardingHome'
                     "
                     :to="homeRoute"
                  >
                     <QItemSection avatar>
                        <QIcon name="mdi-home-outline" />
                     </QItemSection>
                     <QItemSection>Home</QItemSection>
                  </QItem>
                  <QItem
                     clickable
                     :disable="!onboardedWithVariables"
                     :active="route.name == 'CombinationExplorer'"
                     :to="`/orgs/${urlSlug}/projects/${projectStore.projectId}/combination-explorer`"
                  >
                     <QItemSection avatar>
                        <QIcon name="mdi-compass" />
                     </QItemSection>
                     <QItemSection>
                        Combo Explorer
                        <QTooltip v-if="!onboardedWithVariables">{{
                           ComboVariableExplorerTooltip
                        }}</QTooltip>
                     </QItemSection>
                  </QItem>
                  <QItem
                     clickable
                     :disable="!onboardedWithVariables"
                     :active="route.name == 'VariableExplorer'"
                     :to="`/orgs/${urlSlug}/projects/${projectStore.projectId}/variable-explorer`"
                  >
                     <QItemSection avatar>
                        <QIcon name="mdi-chart-multiline" />
                     </QItemSection>
                     <QItemSection>
                        Variable Explorer
                        <QTooltip v-if="!onboardedWithVariables">{{
                           ComboVariableExplorerTooltip
                        }}</QTooltip>
                     </QItemSection>
                  </QItem>
                  <QItem
                     clickable
                     :active="route.name == 'Variables'"
                     :to="`/orgs/${urlSlug}/projects/${projectStore.projectId}/variables`"
                  >
                     <QItemSection avatar>
                        <QIcon name="mdi-variable" />
                     </QItemSection>
                     <QItemSection>Variables</QItemSection>
                  </QItem>
                  <QItem
                     clickable
                     :active="route.name == 'Rewards'"
                     :to="`/orgs/${urlSlug}/projects/${projectStore.projectId}/rewards`"
                  >
                     <QItemSection avatar>
                        <QIcon name="mdi-signal" />
                     </QItemSection>
                     <QItemSection>Rewards</QItemSection>
                  </QItem>
                  <!-- <QItem
                     clickable
                     :active="route.name == 'Checkpoints'"
                     :to="`/orgs/${urlSlug}/projects/${projectStore.projectId}/checkpoints`"
                  >
                     <QItemSection avatar>
                        <QIcon name="mdi-flag-checkered" />
                     </QItemSection>
                     <QItemSection> Checkpoints </QItemSection>
                  </QItem>

                  <QItem
                     clickable
                     :active="route.name == 'History'"
                     :to="`/orgs/${urlSlug}/projects/${projectStore.projectId}/history`"
                  >
                     <QItemSection avatar>
                        <QIcon name="mdi-history" />
                     </QItemSection>
                     <QItemSection> History </QItemSection>
                  </QItem>
                  <QItem
                     clickable
                     :active="route.name == 'Debugger'"
                     :to="`/orgs/${urlSlug}/projects/${projectStore.projectId}/debugger`"
                  >
                     <QItemSection avatar>
                        <QIcon name="mdi-bug-outline" />
                     </QItemSection>
                     <QItemSection> Debugger </QItemSection>
                  </QItem> -->
               </QList>
               <QList>
                  <QItem
                     v-if="isEzbotEmployee"
                     clickable
                     :to="{ name: 'EmployeeDashboard' }"
                  >
                     <QItemSection avatar>
                        <QIcon name="mdi-account-multiple-outline" />
                     </QItemSection>
                     <QItemSection>Invites</QItemSection>
                  </QItem>
                  <QItem
                     clickable
                     :to="`/orgs/${urlSlug}/projects/${projectStore.projectId}/settings`"
                  >
                     <QItemSection avatar>
                        <QIcon name="mdi-cog-outline" />
                     </QItemSection>
                     <QItemSection> Project Settings </QItemSection>
                  </QItem>
                  <QSeparator />
                  <QItem clickable href="https://docs.ezbot.ai" target="_blank">
                     <QItemSection avatar>
                        <QIcon name="mdi-book-outline" />
                     </QItemSection>
                     <QItemSection>Docs</QItemSection>
                  </QItem>
               </QList>
            </QDrawer>
            <!--// Main content //-->
            <QPageContainer class="bg-grey-2">
               <Suspense>
                  <PageLayout>
                     <template #page>
                        <slot />
                     </template>
                  </PageLayout>
               </Suspense>
            </QPageContainer>
         </QLayout>
      </div>
      <HelpFab />
   </div>
</template>

<script setup lang="ts">
import { QIcon, QBtn, useQuasar } from "quasar"
import { computed, onMounted, ref, watch, watchEffect } from "vue"
import { useProjectStore } from "../stores"
import PageLayout from "./PageLayout.vue"
import ProjectPicker from "../components/ProjectPicker.vue"
import { OrgSwitcher, HelpFab, LogoutButton } from "../components"
import { useClerk, UserButton } from "@clerk/vue"
import { useRoute } from "vue-router"
import { useAppState } from "../stores"
import { storeToRefs } from "pinia"
import { EzbotAppJWTPayload, getOrg } from "@/services/clerk"
import { jwtDecode } from "jwt-decode"
import { useOnboardingStore } from "@stores/onboardingStore"

const clerk = useClerk()
const route = useRoute()
const appStore = useAppState()
const $q = useQuasar()

const leftDrawerMiniState = ref(true)
const isEzbotEmployee = ref(false)

const { leftDrawerOpen } = storeToRefs(appStore)

const projectStore = useProjectStore()
const onboardingStore = useOnboardingStore()
const ezbotExtensionInstalled = ref(false)

const org = await getOrg()
if (!org) {
   throw new Error("Org is undefined")
}
const { slug } = org
const urlSlug = ref(slug)

const showDrawer = computed(() => {
   return projectStore.projectId && slug
})

const onboardedWithVariables = computed(() => {
   return onboardingStore.fullyOnboarded && projectStore.variables.length > 0
})

const ComboVariableExplorerTooltip = computed(() => {
   if (!onboardingStore.fullyOnboarded) {
      return "Access after onboarding"
   }

   if (!projectStore.variables.length) {
      return "Variables required"
   }

   return ""
})

const prevProjectId = ref(projectStore.projectId)

watch(
   () => projectStore.projectId,
   async () => {
      if (!projectStore.projectId) {
         return
      }
      if (projectStore.projectId != prevProjectId.value) {
         prevProjectId.value = projectStore.projectId
         await onboardingStore.fetchProjectOnboarding()
         await projectStore.getVariablesByProjectId(projectStore.projectId)
      }
   },
)

onMounted(async () => {
   const extensionInstalled = document.getElementById(
      "ezbot-visual-editor-helper-script",
   )
   if (extensionInstalled) {
      ezbotExtensionInstalled.value = true
   }
   if (!projectStore.projectId) {
      return
   }
   await onboardingStore.fetchProjectOnboarding()
   await projectStore.getVariablesByProjectId(projectStore.projectId)
})

// Reactively check if the user is an Ezbot employee
watchEffect(async () => {
   try {
      // In development mode, treat all users as employees if the flag is set
      if (import.meta.env.VITE_MOCK_EMPLOYEE === "true") {
         console.log("Development mode: Treating user as Ezbot employee")
         isEzbotEmployee.value = true
         return
      }

      const token = await clerk.value?.session?.getToken()
      if (!token) {
         isEzbotEmployee.value = false
         return
      }

      const decoded = jwtDecode(token) as EzbotAppJWTPayload
      isEzbotEmployee.value = decoded.user_metadata?.isEzbotEmployee === true
   } catch (error) {
      console.error("Error checking employee status:", error)
      isEzbotEmployee.value = false
   }
})

const homeRoute = computed(() => {
   if (onboardingStore.fullyOnboarded) {
      return `/orgs/${urlSlug.value}/projects/${projectStore.projectId}`
   }
   return `/orgs/${urlSlug.value}/projects/${projectStore.projectId}/onboarding`
})

</script>

<style type="text/css">
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@100;300&display=swap");

.constrained {
   width: 100%;
   height: 100%;
}

.constrained .q-layout,
.constrained .q-header,
.constrained .q-footer {
   margin: 0 auto;
}

.nav-btn {
   min-width: 90px;
}
.page {
   margin-left: 60px;
}
</style>
